export const AUTOPLAY_GUIDE_ID = 'autoplay';
